<template>
  <settings-template :title="title">
    <select class="form-control form-control-sm" v-model="value">
      <option value="flex-start">Start</option>
      <option value="flex-end">End</option>
      <option value="center">Center</option>
      <option value="space-between">Space Between</option>
      <option value="space-evenly">Space Evenly</option>
    </select>
  </settings-template>
</template>

<script>
import appearanceChangerMixin from "@/mixins/campaign-builder/appearance-changer-mixin"
import SettingsTemplate from "@/components/campaign-builder/settings-elements/SettingsTemplate"

export default {
  name: "SettingsJustifyContent",
  props: {
    variable: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "Justify Content"
    }
  },
  mixins: [appearanceChangerMixin],
  components: { SettingsTemplate },
  computed: {
    value: {
      get() {
        return this.getStyleVariableValue(this.env, this.variable, 0)
      },
      set(value) {
        this.setStyleVariableValue({
          env: this.env,
          variable: this.variable,
          value: value
        })
      }
    }
  }
}
</script>
